import { makeStyles } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';

export interface PageHeadlineProps extends StandardDivProps<PageHeadlineClassKey> {
  actions?: React.ReactNode;
  children: React.ReactNode;
}

export type PageHeadlineClassKey = 'root' | 'title' | 'actions';

const themeSettings = { name: 'SxWebPageHeadline' };
const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      backgroundColor: '#FBFBFB',
      marginTop: theme.spacing(2),
      padding: theme.spacing(5, 5, 3.5, 5),
      borderRadius: theme.shape.borderRadius,
    },
    title: {
      ...theme.typography.h4,
      fontWeight: 300,
      margin: 0,
      color: theme.palette.text.primary,
      flexGrow: 1,
    },
    actions: {},
  }),
  themeSettings,
);

const PageHeadline: React.FC<PageHeadlineProps> = React.forwardRef(
  ({ actions, className, classes: pClasses, children, ...rest }, ref) => {
    const classes = useStyles({ classes: pClasses });

    return (
      <div ref={ref} className={clsx(classes.root, className)} {...rest}>
        <h1 className={classes.title}>{children}</h1>
        {actions && <div className={classes.actions}>{actions}</div>}
      </div>
    );
  },
);

PageHeadline.displayName = 'PageHeadline';

export default withThemeProps(themeSettings)(PageHeadline);
